export default class MissingTranslationError extends Error {}
